import {
  ColorPicker as MantineColorPicker,
  Combobox,
  InputBase,
  useCombobox,
} from '@mantine/core';
import { TextInput } from '@mantine/core';
import { useFocusWithin } from '@mantine/hooks';
import cx from 'clsx';
import { FC, memo } from 'react';
import defaultStyles from 'src/components/Form/styles.default.module.css';
import { useFormContext } from 'src/form';

import styles from './styles.module.css';

type Props = {
  label?: string;
  name: string;
};

export const ColorPicker: FC<Props> = memo(({ label, name }) => {
  const { ref, focused } = useFocusWithin();
  const { ref: inputRef, focused: inputfocused } = useFocusWithin();

  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
  });

  const form = useFormContext();
  const formProps = form.getInputProps(name);
  const value = formProps.value;

  return (
    <div>
      {label && <span className={styles.label}>{label}</span>}
      <Combobox
        store={combobox}
        onOptionSubmit={() => combobox.closeDropdown()}
      >
        <Combobox.Target>
          <InputBase
            classNames={{
              input: cx({ [defaultStyles.input]: true, [styles.box]: true }),
              label: defaultStyles.label,
              root: cx({
                [defaultStyles.root]: true,
                [defaultStyles.rootFocused]: focused,
              }),
              section: styles.section,
            }}
            component="button"
            type="button"
            pointer
            onClick={() => combobox.toggleDropdown()}
            styles={{
              input: {
                background: value,
              },
            }}
            ref={ref}
            {...formProps}
          >
            {value && <span className={styles.value}>{value}</span>}
          </InputBase>
        </Combobox.Target>

        <Combobox.Dropdown className={styles.dropdown}>
          <>
            <MantineColorPicker
              format="hex"
              fullWidth
              classNames={{
                wrapper: styles.picker,
              }}
              value={value}
              onChange={formProps.onChange}
            />

            <TextInput
              ref={inputRef}
              placeholder="Enter HEX Color"
              classNames={{
                input: cx({
                  [defaultStyles.input]: true,
                  [styles.input]: true,
                }),
                root: cx({
                  [defaultStyles.root]: true,
                  [defaultStyles.rootFocused]: inputfocused,
                }),
              }}
              withAsterisk={false}
              value={value}
              onChange={formProps.onChange}
            />
          </>
        </Combobox.Dropdown>
      </Combobox>
    </div>
  );
});
